import { connect } from "react-redux";
import { get } from "micro-dash";

import { fetchCrematoryIfNeeded } from "../../../actions/crematories";
import TableItemView from "./TableItemView";

const mapStateToProps = (state, ownProps) => {
    const ceremony = get(
        state,
        ["entities", "ceremonies", "byId", ownProps.ceremonyId],
        null
    );

    return {
        ceremony,
        room: get(
            state,
            ["entities", "rooms", "byId", get(ceremony, ["item", "room"])],
            null
        )
    };
};

const mapDispatchToProps = dispatch => {
    return {
        fetchDataIfNeeded: () => {
            dispatch(fetchCrematoryIfNeeded());
        }
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(TableItemView);
